<template lang="pug">
  div
    //-section.content-header
      app-messages(:errorMessages="$store.state.base.flashMessages")
      app-messages(:errorMessages="errors", :successMessages="successes")

    section.content
      .bcard-btnbar.clearfix
        router-link.btn.btn-default(v-if="fromPage === 'merge-persons-list'", :to="{name: 'merge-persons-list'}" title="戻る"): i.fa.fa-reply
        router-link.btn.btn-default(v-else, :to="{name: 'top'}" data-testid="btn-return-top") TOPページに戻る

      //-.callout.callout-info.bcard-callout
        h4 名寄せ候補の人物と登録済みの人物を同一人物として統合できます。
        p 名寄せ候補と同一人物候補が同一人物か判定してください。
          br
          | 同一人物候補が複数ある場合は同一人物候補一覧から選択してください。

      .row
        .col-sm-6
          .panel.panel-default(data-testid="content-target")
            .panel-heading.duplicate-panel-heading
              h4 名寄せ対象
            .panel-body
              //- 読み込み中はぐるぐる表示
              loading(v-if="isLoadingTarget")

              //- 読み込み終わったらコンテンツ表示
              scroll-sync(v-else, vertical)
                .form-group
                  .bcard-card-details-card-img.text-center(data-testid="-info-bcard-image")
                    a(v-if="target.image_url && target.image_url.length !== 0" href="#" @click.prevent="showCardImageModal(target.id)")
                      img.bcard-card-details-card-img(:src="app_imgsrc.now_loading" v-src="target.image_url")
                    img.bcard-card-details-card-img(v-else :src="app_imgsrc.now_loading" v-src="target.image_url")

                .form-group
                  label 名刺交換日
                  |
                  |
                  strong(data-testid="-info-exdate") {{target.formatted_exdate}}
                  br
                  label 名刺交換者
                  |
                  |
                  //- TODO API修正後「target.exchanges &&」は消せる
                  strong(data-testid="-info-exchanger-full-name") {{target.exchanges && target.exchanges[0].exchanger_full_name}}

                hr

                .form-group
                  label 氏名
                  p.form-control-static(data-testid="-info-full-name") {{target.full_name}}
                .form-group
                  label 氏名（よみがな）
                  p.form-control-static(data-testid="-info-full-kana") {{target.full_kana}}
                .form-group
                  label 会社名
                  p.form-control-static(data-testid="-info-corporate-name") {{target.corporate_name}}
                .form-group
                  label 会社名（よみがな）
                  p.form-control-static(data-testid="-info-corporate-kana") {{target.corporate_kana}}
                .form-group
                  label カンパニー名
                  p.form-control-static(data-testid="-info-company-name") {{target.company_name}}
                .form-group
                  label カンパニー名（よみがな）
                  p.form-control-static(data-testid="-info-company-kana") {{target.company_kana}}
                .form-group
                  label 部署名
                  p.form-control-static(data-testid="-info-dept") {{target.dept}}
                .form-group
                  label 役職
                  p.form-control-static(data-testid="-info-post") {{target.post}}
                .form-group
                  label 部署名＋役職
                  p.form-control-static(data-testid="-info-dept-post") {{target.dept_post}}

                //- 事業所
                #jbcard-target-accordion.box-group(v-if="!isInitTargetOffice", role="tablist" aria-multiselectable="true")
                  office-accordion(officeNo="1", :officeInfo="targetOffice1")
                  office-accordion(officeNo="2", :officeInfo="targetOffice2")

                .text-right
                  router-link(target="_blank", :to="{name: 'box-detail', params: {sidPerson: target.sid_person}}" data-testid="-link-view-target-data") すべての情報を見る
                    |
                    |
                    i.fa.fa-external-link

        .col-sm-6
          .panel.panel-default(data-testid="content-duplicates")
            .panel-heading.duplicate-panel-heading(v-if="!isCandidate || !targetFlag")
              h4 同一人物候補
            .panel-heading.duplicate-panel-heading(v-else)
              .pull-right
                .btn-group
                  a.btn.btn-default(href="#jbcard-card-details-cardinfo-carousel" data-slide="prev" title="前の名刺へ", :disabled="isFirstCard", @click.prevent="gotoPrev" data-testid="-btn-prev")
                    i.fa.fa-angle-left
                  button.btn.btn-primary(type="button" @click="_openModalMergePersonsConf(target, duplicates[activeIndex])" data-testid="-btn-merge")  同一人物
                  button.btn.btn-default(type="button", @click="modalAnotherPersonsConf_isOpen = true" data-testid="-btn-not-merge")  別人
                  a.btn.btn-default(href="#jbcard-card-details-cardinfo-carousel" data-slide="next" title="次の名刺へ", :disabled="isLastCard", @click.prevent="gotoNext" data-testid="-btn-next")
                    i.fa.fa-angle-right
              h4 <!--名寄せ対象と-->同一人物ですか？

            .panel-body
              //- 読み込み中はぐるぐる表示
              loading(v-if="isLoadingDuplicates", :height="400")
              scroll-sync(v-else, vertical)
                // 同一人物候補：同一人物候補なし or 判定終了
                div(v-if="(!isLoadingDuplicates && !isCandidate) || !targetFlag")
                  .not-selected.message
                    button.btn.btn-primary(v-if="isJudged === app_flag.OFF" , type="button" @click="openModalComplete") 同一人物なし
                    .form-group(v-else)
                      p 同一人物の判定は完了しています。
                      |
                      br
                      |
                      button.btn.btn-primary.return-list-btn(type="button" @click="returnList") 一覧に戻る
                // 同一人物候補：選択中
                div(v-else="!isLoadingDuplicates && isCandidate")
                  #jbcard-card-details-cardinfo-carousel.carousel.slide.bcard-card-details-cardinfo-carousel(data-interval="false" data-wrap="false")
                    .carousel-inner
                      .item(v-for="(person, index) in duplicates", :key="index", :class="{active: index === activeIndex}", :data-id="person.id")
                        .form-group
                          center
                            a(v-if="person.latest_bcard.image_url && person.latest_bcard.image_url.length !== 0" href="#" @click.prevent="showCardImageModal(person.latest_bcard.id)")
                              img.bcard-card-details-card-img(:src="app_imgsrc.now_loading" v-src="person.latest_bcard.image_url")
                            img.bcard-card-details-card-img(v-else :src="app_imgsrc.now_loading" v-src="person.image_url")

                        .form-group
                          label 名刺交換日
                          |
                          |
                          strong(data-testid="-info-exdate") {{person.formatted_exdate}}
                          br
                          label 名刺交換者
                          |
                          |
                          //- TODO API修正後「person.latest_bcard.exchanges &&」は消せる
                          strong(data-testid="-info-exchanger-full-name") {{person.latest_bcard.exchanges[0].exchanger_full_name}}

                        hr

                        .form-group
                          label 氏名
                          p.form-control-static(data-testid="-info-full-name") {{person.latest_bcard.full_name}}
                        .form-group
                          label 氏名（よみがな）
                          p.form-control-static(data-testid="-info-full-kana") {{person.latest_bcard.full_kana}}
                        .form-group
                          label 会社名
                          p.form-control-static(data-testid="-info-corporate-name") {{person.latest_bcard.corporate_name}}
                        .form-group
                          label 会社名（よみがな）
                          p.form-control-static(data-testid="-info-corporate-kana") {{person.latest_bcard.corporate_kana}}
                        .form-group
                          label カンパニー名
                          p.form-control-static(data-testid="-info-company-name") {{person.latest_bcard.company_name}}
                        .form-group
                          label カンパニー名（よみがな）
                          p.form-control-static(data-testid="-info-company-kana") {{person.latest_bcard.company_kana}}
                        .form-group
                          label 部署名
                          p.form-control-static(data-testid="-info-dept") {{person.latest_bcard.dept}}
                        .form-group
                          label 役職
                          p.form-control-static(data-testid="-info-post") {{person.latest_bcard.post}}
                        .form-group
                          label 部署名＋役職
                          p.form-control-static(data-testid="-info-dept-post") {{person.latest_bcard.dept_post}}

                        //- 事業所
                        #jbcard-person-accordion.box-group(role="tablist" aria-multiselectable="true")
                          office-accordion(officeNo="1", :officeInfo="_fetchBcardOffice(person.latest_bcard, 1)")
                          office-accordion(officeNo="2", :officeInfo="_fetchBcardOffice(person.latest_bcard, 2)")

                        .text-right
                          router-link(target="_blank", :to="{name: 'box-detail', params: {sidPerson: person.id}}" data-testid="-link-view-duplicates-data") すべての情報を見る
                            |
                            |
                            i.fa.fa-external-link

      .panel.panel-default(data-testid="content-duplicates-list")
        .panel-heading
          .pull-right
            button.btn.btn-primary(type="submit" title="検索" @click="openModalSearchDups" data-testid="-btn-card-search")
              i.fa.fa-search
            |
            |
            app-sortmenu(:hidden="duplicates.length === 0", :options="sortOptions", :current="currParams.sort" @change="sortList")
          h4 同一人物候補一覧

        .panel-body
          .candidates
            loading(v-if="isLoadingDuplicates")
            ul.list-group(v-else-if="(!isLoadingDuplicates && isCandidate) && targetFlag")
              template
                li.list-group-item(
                  href="#",
                  v-for="(person, index) in duplicates",
                  :key="person.id",
                  :class="{'selected': isActive(person)}",
                  :data-slide-to="index",
                  data-target="#jbcard-card-details-cardinfo-carousel",
                  @click.prevent="setIndex($event, index)",
                  :data-testid="person.full_name"
                )
                  //- TODO API
                  .helper(title="この名刺を表示する")
                    person-data(
                      :person="person",
                      @clickCard="openCard"
                    )
                    //.media.bcard-card-media.with-image
                      .media-left
                        img.media-object.bcard-card-img(:src="app_imgsrc.no_image")
                      .media-body
                        h4.media-heading
                          a(href='#', @click.prevent="openCard", data-testid="-link-name")
                            i.fa.fa-fw.bcard-fa-person-private(v-if="person.openflag === '0'" title="非公開")
                            | {{person.full_name}}
                        li(v-if="person.corporate_name") {{person.corporate_name}}
                        li(v-if="person.dept") {{person.dept}}
                        li(v-if="person.post") {{person.post}}
            p.not-candidates(v-else-if="(!isLoadingDuplicates && !isCandidate) || !targetFlag")
              | 同一人物の候補がいません。
              br
              | 検索条件を変えて、候補を検索できます。

      //- modal
      //- エラー
      app-modal(type="warning", v-model="modalError_isOpen")
        template(slot="title") {{modalError_title || 'エラー'}}
        app-messages(:defaultMessages="errors")

      //- 判定済み確認
      app-modal(type="primary", v-model="modalCompleteConf_isOpen")
        template(slot="title") 判定済み確認
        h4(v-if="!isLoadingTarget") {{target.full_name}} さんを判定済みにします。よろしいですか？
        p 判定済みになった名刺は名寄せ候補名刺一覧に表示されなくなります。
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="button", @click="complete") 判定済み
          button.btn.btn-default(type="button", @click="close") キャンセル

      //- 統合確認
      app-modal(type="primary", v-model="modalMergePersonsConf_isOpen" data-testid="merge-person-modal")
        template(slot="title") 人物統合の確認
        h4 この人物を統合しますか？
        p.bcard-comments.text-info ※ 検索キーワード・個人メモは自動で連結され、名刺交換者に通知が送信されます。
        hr
        label 最新名刺を手動で設定できます
        .radio.radio-rich
          label
            input(
              type="radio",
              name="newer_id",
              v-model="modalMergePersonsConf_newerId",
              :value="modalMergePersonsConf_id1"
              data-testid="-radio-latest-left"
            )
            span: i.fa.fa-dot-circle-o.fa-lg
            | 左側が最新名刺
          label
            input(
              type="radio",
              name="newer_id",
              v-model="modalMergePersonsConf_newerId",
              :value="modalMergePersonsConf_id2",
              data-testid="-radio-latest-right"
            )
            span: i.fa.fa-dot-circle-o.fa-lg
            | 右側が最新名刺
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="button", @click="mergePersons" data-testid="-btn-merge-person") 統合
          button.btn.btn-default(type="button", @click="close" data-testid="-btn-cancel") キャンセル

      //- 競合確認
      app-modal(type="primary", size="large", v-model="modalMergePersonData_isOpen" data-testid="merge-person-check-modal")
        template(slot="title") 同一人物登録の確認
        app-messages(:errorMessages="errors")

        h4 左側の人物と右側の物の情報が競合しています。
        p 残したい内容を選択し、統合を実行してください。
        .help-block
          p.bcard-comments.text-info ※ 検索キーワード・個人メモは自動で連結され、名刺交換者に通知が送信されます。

        //- 競合リスト
        div.bcard-table-list-container.bcard-duplicate-conf-list
          div.panel.panel-default
            div.table-responsive.bcard-table-container.-height-auto
              table.table.table-bordered.bcard-table
                thead
                  tr
                    th.bcard-table-td-conf-items(style="width: 8em")
                    th 左側の人物情報
                    th(style="width: 4em")
                    th 右側の人物情報
                tbody
                  tr(v-if="'openflag' in modalMergePersonData_competed" data-testid="-content-openflag")
                    th 公開区分
                    td: .radio.radio-rich
                      label(data-testid="-select-left")
                        template(v-if="modalMergePersonData_competed.openflag[modalMergePersonsConf_id1] === app_flag.ON")
                          i.fa.bcard-fa-person-public.fa-fw
                          | 公開
                        template(v-else)
                          i.fa.bcard-fa-person-private.fa-fw
                          | 非公開
                        input(
                          type="radio",
                          name="modalMergePersonData_openflag",
                          :value="modalMergePersonData_competed.openflag[modalMergePersonsConf_id1]",
                          v-model="modalMergePersonData_openflag"
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                    td
                    td: .radio.radio-rich
                      label(data-testid="-select-right")
                        template(v-if="modalMergePersonData_competed.openflag[modalMergePersonsConf_id2] === app_flag.ON")
                          i.fa.bcard-fa-person-public.fa-fw
                          | 公開
                        template(v-else)
                          i.fa.bcard-fa-person-private.fa-fw
                          | 非公開
                        input(
                          type="radio",
                          name="modalMergePersonData_openflag",
                          :value="modalMergePersonData_competed.openflag[modalMergePersonsConf_id2]",
                          v-model="modalMergePersonData_openflag"
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg

                  tr(v-if="'twitter_id' in modalMergePersonData_competed" data-testid="-content-twitter-id")
                    th Twitter ID
                    td: .radio.radio-rich
                      label(data-testid="-select-left")
                        input(
                          type="radio",
                          name="modalMergePersonData_twitter_id",
                          :value="modalMergePersonData_competed.twitter_id[modalMergePersonsConf_id1]",
                          v-model="modalMergePersonData_twitter_id",
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                      span.bcard-duplicate-inline
                        input.form-control(type="text",
                          v-model="modalMergePersonData_competed.twitter_id[modalMergePersonsConf_id1]",
                          @input="setCompetedField('twitter_id', modalMergePersonsConf_id1)",
                          :maxlength="maxlengths.persons.twitter_id"
                        )
                    td.merge-buttons
                      button.btn.btn-default(type="button" @click="copyCompetedField('twitter_id', 'right')") &rarr;
                      br
                      button.btn.btn-default(type="button" @click="copyCompetedField('twitter_id', 'left')") &larr;
                    td: .radio.radio-rich
                      label(data-testid="-select-right")
                        input(
                          type="radio",
                          name="modalMergePersonData_twitter_id",
                          :value="modalMergePersonData_competed.twitter_id[modalMergePersonsConf_id2]",
                          v-model="modalMergePersonData_twitter_id",
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                      span.bcard-duplicate-inline
                        input.form-control(type="text",
                          v-model="modalMergePersonData_competed.twitter_id[modalMergePersonsConf_id2]",
                          @input="setCompetedField('twitter_id', modalMergePersonsConf_id2)",
                          :maxlength="maxlengths.persons.twitter_id"
                        )

                  tr(v-if="'blog_url' in modalMergePersonData_competed" data-testid="-content-blog-url")
                    th ブログURL
                    td: .radio.radio-rich
                      label(data-testid="-select-left")
                        input(
                          type="radio",
                          name="modalMergePersonData_blog_url",
                          :value="modalMergePersonData_competed.blog_url[modalMergePersonsConf_id1]",
                          v-model="modalMergePersonData_blog_url",
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                      span.bcard-duplicate-inline
                        input.form-control(type="text",
                          v-model="modalMergePersonData_competed.blog_url[modalMergePersonsConf_id1]",
                          @input="setCompetedField('blog_url', modalMergePersonsConf_id1)",
                          :maxlength="maxlengths.persons.blog_url"
                        )
                    td.merge-buttons
                      button.btn.btn-default(type="button" @click="copyCompetedField('blog_url', 'right')") &rarr;
                      br
                      button.btn.btn-default(type="button" @click="copyCompetedField('blog_url', 'left')") &larr;
                    td: .radio.radio-rich
                      label(data-testid="-select-right")
                        input(
                          type="radio",
                          name="modalMergePersonData_blog_url",
                          :value="modalMergePersonData_competed.blog_url[modalMergePersonsConf_id2]",
                          v-model="modalMergePersonData_blog_url",
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                      span.bcard-duplicate-inline
                        input.form-control(type="text",
                          v-model="modalMergePersonData_competed.blog_url[modalMergePersonsConf_id2]",
                          @input="setCompetedField('blog_url', modalMergePersonsConf_id2)",
                          :maxlength="maxlengths.persons.blog_url"
                        )

                  tr(v-if="'memo' in modalMergePersonData_competed" data-testid="-content-memo")
                    th 共有メモ
                    td: .radio.radio-rich
                      label(data-testid="-select-left")
                        input(
                          type="radio",
                          name="modalMergePersonData_memo",
                          :value="modalMergePersonData_competed.memo[modalMergePersonsConf_id1]",
                          v-model="modalMergePersonData_memo",
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                      span.bcard-duplicate-inline
                        textarea.form-control(
                          v-model="modalMergePersonData_competed.memo[modalMergePersonsConf_id1]",
                          @input="setCompetedField('memo', modalMergePersonsConf_id1)",
                          :maxlength="maxlengths.persons.memo"
                        )
                    td.merge-buttons
                      button.btn.btn-default(type="button" @click="copyCompetedField('memo', 'right')") &rarr;
                      br
                      button.btn.btn-default(type="button" @click="copyCompetedField('memo', 'left')") &larr;
                    td: .radio.radio-rich
                      label(data-testid="-select-right")
                        input(
                          type="radio",
                          name="modalMergePersonData_memo",
                          :value="modalMergePersonData_competed.memo[modalMergePersonsConf_id2]",
                          v-model="modalMergePersonData_memo",
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                      span.bcard-duplicate-inline
                        textarea.form-control(
                          v-model="modalMergePersonData_competed.memo[modalMergePersonsConf_id2]",
                          @input="setCompetedField('memo', modalMergePersonsConf_id2)",
                          :maxlength="maxlengths.persons.memo"
                        )

        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(
          :class="{disabled: !validMergePersonsAgain()}",
          type="button",
          @click="mergePersonsAgain",
          data-testid="-btn-merge-person"
          ) 統合
          button.btn.btn-default(type="button", @click="close" data-testid="-btn-cancel") キャンセル

      //- 別人確認
      app-modal(type="default", v-model="modalAnotherPersonsConf_isOpen" data-testid="another-person-modal")
        template(slot="title") 別人判定の確認
        h4 この人物を別人と判定してよろしいですか？
        p.bcard-comments.text-info ※ 別人判定を行うと、画面下の同一人物候補一覧からこの人物が見えなくなります。
        p.bcard-comments.text-info ※ やり直したい場合は、同一人物候補一覧でこの人物を検索してください。
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="button", @click="isAnotherPerson" data-testid="-btn-another-person") 別人
          button.btn.btn-default(type="button", @click="close" data-testid="-btn-cancel") キャンセル

      //- 同一人物の検索
      app-modal(type="default", v-model="modalSearchDups_isOpen" data-testid="-duplicate-search-modal")
        template(slot="title") 同一人物の検索
        template(slot-scope="{close}")
          .row
            .col-xs-8.form-group
              label.control-label 氏名
              input.form-control(type="text" name="jbcard_name" placeholder="氏名、氏名（よみがな）を前方一致で検索します" v-model="modalSearchDups_searchName" @keyup.enter="close(); searchDuplicates();" data-testid="-input-jbcard-name")
            .col-xs-4.form-group
              label
              .checkbox.checkbox-rich
                label(data-testid="-checkbox-search-name-strict")
                  input(type="checkbox" v-model="modalSearchDups_searchNameStrict" @keyup.enter="close(); searchDuplicates();")
                  span: i.fa.fa-check.fa-lg
                  | 完全一致で検索する

          .form-group
            label.control-label 会社名
            input.form-control(type="text" name="jbcard_comp" placeholder="会社名、会社名（よみがな）を部分一致で検索します" v-model="modalSearchDups_searchCorporateName" @keyup.enter="close(); searchDuplicates();" data-testid="-input-jbcard-comp")
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="button", @click="close(); searchDuplicates();" data-testid="-btn-search") 検索
          button.btn.btn-default(type="button", @click="close" data-testid="-btn-cancel") キャンセル

      //- 名刺情報
      modal-bcard(v-model="modalBcard")

      //- 名刺画像ダイアログ
      portal(to="popup")
        modal-images(v-model="modalImages")
</template>

<script>
import ScrollSync from 'vue-scroll-sync'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import AppSortmenu from '@/components/molecules/AppSortmenu'
import Loading from '@/components/molecules/Loading'
import FuncAdvancedSearch from '@/components/organisms/functions/FuncAdvancedSearch'
import ModalBcard from '@/components/organisms/ModalBcard'
import ModalImages from '@/components/organisms/ModalImages'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import OfficeAccordion from '@/components/organisms/ModalLatestBcardOffice'
import CardList from '@/components/organisms/lists/CardList'
import PersonData from './_DetailPersonData'

// mock用
import { repository as repoEnv } from 'static/config'
const IS_MOCK = repoEnv.isMock

const PersonRepository = RepositoryFactory.get('person')
const MergePersonRepository = RepositoryFactory.get('mergeperson')

export default {
  name: 'DuplicatedPersons',
  components: {
    ScrollSync,
    AppModal,
    AppMessages,
    AppSortmenu,
    Loading,
    FuncAdvancedSearch,
    ModalBcard,
    ModalImages,
    OfficeAccordion,
    CardList,
    PersonData
  },
  props: {
    value: {
      type: Object,
      required: false,
      default () {
        return {
          person_id: null
        }
      }
    },
    id: { type: [String, Number], required: true }
  },
  data () {
    return {
      fromPage: '',
      targetFlag: true, // [モック用]同一人物候補有無：出し分けフラグ
      isJudged: '', // 判定済み app_flag
      activeIndex: 0, // 現在表示している名刺の要素番号
      isBcardChanging: false, // 名刺切り替え中フラグ
      /**
       * 対象人物ID
       */
      sidPerson: '',
      // 初回だけ対象人物取得後に同一人物候補情報を取得するフラグ
      initialLoaded: false,
      // 判定済み確認モーダル
      modalCompleteConf_isOpen: false,
      /**
       * 対象人物情報
       */
      isLoadingTarget: true,
      target: {},
      isInitTargetOffice: false,
      /**
       * 同一人物候補一覧
       */
      isLoadingDuplicates: true,
      duplicates: [],
      // duplicates配列のうち何番目を初期表示にするか
      startIndex: {
        type: [Number],
        required: false,
        default: 0
      },
      /**
       * 同一人物候補
       */
      // 検索モーダル
      modalSearchDups_isOpen: false,
      modalSearchDups_searchName: '',
      modalSearchDups_searchNameStrict: true,
      modalSearchDups_searchCorporateName: '',
      // 名刺情報モーダル
      modalBcard: {
        isOpen: false,
        sidPerson: ''
      },
      /**
       * 統合
       */
      isPersonDraggable: false,
      isPersonDragging: false,
      // 確認モーダル
      modalMergePersonsConf_isOpen: false,
      modalMergePersonsConf_id1: null,
      modalMergePersonsConf_id2: null,
      modalMergePersonsConf_newerId: null,
      // 競合データ変更モーダル
      modalMergePersonData_isOpen: false,
      modalMergePersonData_competed: {
        // リアクティブにするため定義
        openflag: [],
        twitter_id: [],
        blog_url: [],
        memo: []
      },
      modalMergePersonData_openflag: null, // 空文字更新と区別するため
      modalMergePersonData_twitter_id: null, // 空文字更新と区別するため
      modalMergePersonData_blog_url: null, // 空文字更新と区別するため
      modalMergePersonData_memo: null, // 空文字更新と区別するため
      /**
       * エラーモーダル
       */
      modalError_isOpen: false,
      modalError_title: '',
      // ソート項目リスト
      sortOptions: [
        {'label': '氏名', 'sort_item': 'name'},
        {'label': '会社名', 'sort_item': 'corporate_name'},
        {'label': '名刺交換日', 'sort_item': 'exchange_date'}
      ],
      // 現在の条件
      currParams: {
        // ページ条件
        page: { page: 1 },
        // ソート条件
        sort: { sort_item: 'name', direction: 'asc' },
        // 検索条件
        conds: {}
      },
      /**
       * 別人
       */
      modalAnotherPersonsConf_isOpen: false,
      /**
       * 最新の名刺情報モーダル
       */
      modalLatestBcard_isOpen: false,
      modalLatestBcard_personId: null,
      // 入力欄のmaxlengthの値
      maxlengths: {},
      /**
       * 名刺の画像ダイアログ
       */
      modalImages: {
        isOpen: false,
        sid_bcard: null
      }
    }
  },
  computed: {
    login_user () {
      return (this.$store.state.base.u && this.$store.getState('login_user')) || {}
    },
    targetOffice1 () {
      return this._fetchBcardOffice(this.target, 1)
    },
    targetOffice2 () {
      return this._fetchBcardOffice(this.target, 2)
    },
    // 今表示されている名刺ID
    activeId () {
      return this.duplicates[this.activeIndex].id
    },
    // 現在、先頭の名刺を表示しているかどうか
    isFirstCard () {
      return this.activeIndex === 0
    },
    // 現在、最後尾の名刺を表示しているかどうか
    isLastCard () {
      return this.activeIndex === this.duplicates.length - 1
    },
    // 同一人物候補の有無
    isCandidate () {
      return this.duplicates.length > 0
    }
  },
  watch: {
    // 親で読み込みが終わったら実行する
    isLoadingDuplicates (to, from) {
      // // ローディングが終わった場合
      // if (!after && before) {
      //   // watchが終わらないと画面が再描画されないので、DOMを取得するために先にwatchを終わらせる
      //   setTimeout(() => {
      //     this._resetDndUi()
      //   }, 1)
      // }
      if (to === false && from === true) {
        // 初回読み込みのみ実行する
        if (this.isFirstLoad === true) {
          // 何番目の名刺を表示するか
          this.activeIndex = this.startIndex > 0 ? this.startIndex : 0

          this.isFirstLoad = false
        }
        // // 名刺が減った時に表示indexが名刺数を超える場合、最古になる名刺を表示するように変更
        // if (this.activeIndex >= this.duplicates.length) {
        //   this.activeIndex = this.duplicates.length - 1
        // }

        const vm = this
        // 名刺一覧のイベント付加(再度読み込みの度にリセットされるので毎回呼び出す)
        this.$nextTick(function () {
          vm.setEventToCarousel()
        })
      }
    },
    activeIndex (newValue) {
      // 0より小さくなったら初期化する
      if (newValue < 0) {
        this.activeIndex = 0
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromPage = from.name
    })
  },
  created () {
    this.sidPerson = this.id
    // 対象人物取得
    this._getTargetPersonData(this.sidPerson)
    // 同一人物候補は検索条件が不明なので、対象人物取得後に行っている

    this.maxlengths.users = this.loadMaxlengths('Users')
    this.maxlengths.persons = this.loadMaxlengths('Persons')
    // // モック用：対象人物ID表示分け
    // this.judgeTargetId()
    // this.searchDuplicates(
  },
  methods: {
    // モック用：対象人物IDの出し分け
    judgeTargetId  () {
      if (this.$route.params.id !== '1') {
        this.targetFlag = false
      }
    },
    /**
     * 同一人物候補を検索する
     */
    searchDuplicates () {
      this._getDuplicatesData(false)
    },
    /**
     * 同一人物一覧から余分なデータをのぞく
     */
    _filterDuplicates () {
      let tmp = this.duplicates
      this.duplicates = []
      for (let i = 0, len = tmp.length; i < len; i++) {
        if (this.target.sid_person !== tmp[i].id) {
          this.duplicates.push(tmp[i])
        }
      }
    },
    /**
     * 人物の最新名刺情報を取得する
     */
    _getLatestBcardData () {
      const vm = this
      for (let person of vm.duplicates) {
        for (let bcard of person.bcards) {
          if (person.new_id === bcard.id) {
            person.latest_bcard = bcard
            break
          }
        }
      }
    },
    /**
     * 同一人物候補を取得する
     * @param bool isSort 並び替えボタン判定
     * @param Object conditions nullの場合はリロード
     */
    _getDuplicatesData (isSort, conditions) {
      const vm = this

      // 現在の条件を保持しておく
      if (conditions) {
        vm.modalSearchDups_searchName = conditions.search_name
        vm.modalSearchDups_searchNameStrict = conditions.search_name_strict
        vm.modalSearchDups_searchCorporateName = conditions.search_corporate_name
      }

      // ローディング中アイコンを表示する
      vm.isLoadingDuplicates = true
      vm.isInitTargetOffice = true

      this.clearMessages()

      // 検索から
      if (!isSort) {
        PersonRepository.postSearch({
          search_name: this.modalSearchDups_searchName,
          search_name_strict: this.modalSearchDups_searchNameStrict ? this.app_flag.ON : this.app_flag.OFF,
          search_corporate_name: this.modalSearchDups_searchCorporateName,
          get_bcards: this.app_flag.ON
        },
        this.isMgmt
        )
          .then(function (response) {
            const data = vm.getApiData(response).data
            vm.duplicates = data
            vm._filterDuplicates()
            // 最新名刺情報を取得する
            vm._getLatestBcardData()
            // デフォルトソート列保存
            vm.sort = 'name'
            vm.direction = 'asc'
            // 同一人物候補の先頭を選択するようにする
            vm.activeIndex = 0
          })
          .catch(function (error) {
            vm.setErrorMessage(error)
            vm.modalError_isOpen = true
            vm.modalError_title = '同一人物候補の取得エラー'
          })
          .finally(function () {
            // ローディング中アイコンを解除する
            vm.isLoadingDuplicates = false
            vm.isInitTargetOffice = false
          })
      }
      // 並び替えから
      else {
        PersonRepository.postSearch({
          sort_item: this.currParams.sort.sort_item || null,
          direction: this.currParams.sort.direction || null,
          search_name: this.modalSearchDups_searchName,
          search_name_strict: this.modalSearchDups_searchNameStrict ? this.app_flag.ON : this.app_flag.OFF,
          search_corporate_name: this.modalSearchDups_searchCorporateName,
          get_bcards: this.app_flag.ON
        })
          .then(function (response) {
            const data = vm.getApiData(response).data
            vm.duplicates = data
            vm._filterDuplicates()
            // 最新名刺情報を取得する
            vm._getLatestBcardData()
            // 同一人物候補の先頭を選択するようにする
            vm.activeIndex = 0
          })
          .catch(function (error) {
            vm.setErrorMessage(error)
            vm.modalError_isOpen = true
            vm.modalError_title = '同一人物候補の取得エラー'
          })
          .finally(function () {
            // ローディング中アイコンを解除する
            vm.isLoadingDuplicates = false
            vm.isInitTargetOffice = false
          })
      }
    },
    /**
     * 判定済み確認モーダルを開く
     */
    openModalComplete () {
      this.modalCompleteConf_isOpen = true
    },
    /**
     * 一覧に戻る
     */
    returnList () {
      this.modalCompleteConf_isOpen = false
      this.$router.push({name: 'merge-persons-list'})
    },
    /**
     * 判定済み
     */
    complete () {
      this.onComplete(function (vm) {
        vm.modalCompleteConf_isOpen = false
        vm.$router.push({name: 'merge-persons-list'})
      })
    },
    onComplete (callback) {
      const vm = this
      MergePersonRepository.complete(this.sidPerson)
        .then(function (response) {
          // 成功時
          if (vm.isApiSuccess(response)) {
            // 判定済みとする
            vm.isJudged = vm.app_flag.ON
            callback(vm)
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
          vm.modalError_isOpen = true
          vm.modalError_title = '判定済みエラー'
        })
    },
    /**
     * 対象人物情報を取得する
     * @param Integer|String sidPerson
     */
    _getTargetPersonData (sidPerson) {
      const vm = this

      // ローディング中アイコンを表示する
      this.isLoadingTarget = true

      this.clearMessages()
      MergePersonRepository.getLatestBcard(sidPerson, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data

          // #687 交換したことがない名刺人物の場合、404エラーとする
          // 管理モードの場合は除く
          if (!vm.isMgmt && data.is_exchanged !== vm.app_flag.ON) {
            vm.setErrorMessage({message: 'データが見つかりませんでした。'})
            // 名寄せ一覧へ遷移
            vm.$router.push({name: 'merge-persons-list'})
            vm.$store.commit('setFlashMessages', vm.errors)
          }

          vm.target = data
          // ローディング中アイコンを解除する
          vm.isLoadingTarget = false
          vm.isJudged = vm.target.is_judged

          // 表示用名刺画像を取得
          for (let i = 0; i < vm.target.images.length; i++) {
            if (vm.target.image_id === vm.target.images[i].sid_attach) {
              vm.target.image_url = vm.target.images[i].image_url
              vm.target.image_name = vm.target.images[i].name
            }
          }

          // 初回だけ対象人物の同一人物判定氏名を使って候補を検索する
          if (!vm.initialLoaded) {
            vm._getDuplicatesData(false, {
              search_name: vm.isJudge
                // 判定画面の場合、同一人物判定バッチで保存した検索用氏名かな
                // TODO APIから取得できるようにする
                ? vm.target.judged_search_kana
                // 設定画面の場合、氏名かな
                : vm.target.full_kana,
              search_name_strict: vm.modalSearchDups_searchNameStrict
            })
            vm.initialLoaded = true
          }
        })
        .catch(function (error) {
          // データが無い場合は一覧へ
          if (vm.isErrorNotFound(error)) {
            vm.setErrorMessage(error)
            vm.modalError_isOpen = true
            vm.modalError_title = '対象人物情報の取得エラー'
            vm.$router.push({name: 'merge-persons-list'})
            vm.$store.commit('setFlashMessages', vm.errors)
          }
          vm.setErrorMessage(error)
          vm.modalError_isOpen = true
          vm.modalError_title = '対象人物情報の取得エラー'
        })
    },
    /**
     * @paramn {Object} bcard
     * @param {Number} num
     */
    _fetchBcardOffice (bcard, num) {
      let office = {}
      for (let field in bcard) {
        if (field.substr(0, 3) === `o${num}_`) {
          office[field.substr(3)] = bcard[field]
        }
        if (field === `valid_o${num}_url`) {
          office['valid_url'] = bcard[field]
        }
      }
      return office
    },
    /**
     * 同一人物候補検索モーダルを開く
     */
    openModalSearchDups () {
      this.modalSearchDups_isOpen = true
    },
    // 一つ新しい名刺を表示する
    gotoPrev () {
      if (this.isFirstCard === false && this.isBcardChanging === false) {
        this.activeIndex--
      }
    },
    // 一つ古い名刺を表示する
    gotoNext () {
      if (this.isLastCard === false && this.isBcardChanging === false) {
        this.activeIndex++
      }
    },
    // 特定の番号の名刺へ遷移する
    setIndex ($event, index) {
      if (this.isBcardChanging === false) {
        this.activeIndex = index
      }
      else {
        $event.stopPropagation()
      }
    },
    // 名刺切り替えイベントの追加
    setEventToCarousel () {
      const $carousel = $('#jbcard-card-details-cardinfo-carousel')
      const vm = this
      // 名刺切替中に実行しないようにする
      $carousel.on('slide.bs.carousel', function () {
        vm.isBcardChanging = true
      })
      $carousel.on('slid.bs.carousel', function () {
        vm.isBcardChanging = false
      })
    },
    /**
     * 同一人物候補：有
     */
    // 選択中かどうかを返す
    isActive (item) {
      return item.id === this.activeId
    },
    // 別人とする
    isAnotherPerson () {
      this.onComplete(function (vm) {
        // 確認モーダルを閉じる
        vm.modalAnotherPersonsConf_isOpen = false
        // 同一人物候補を一覧から消す
        vm.removePerson()
      })
    },
    // 同一人物候補を一覧から消す
    removePerson () {
      // 最後尾の候補情報を選択している場合
      if (this.isLastCard) {
        const index = this.activeIndex
        this.duplicates.splice(index, 1)
        this.activeIndex--
      }
      else {
        const index = this.activeIndex
        this.duplicates.splice(index, 1)
      }
    },
    /**
     * 人物統合確認モーダルを表示する
     */
    _openModalMergePersonsConf (target, candidate) {
      const sidPerson = target.sid_person
      const sidAssign = candidate.id
      this.modalMergePersonsConf_isOpen = true
      this.modalMergePersonsConf_id1 = sidPerson
      this.modalMergePersonsConf_id2 = sidAssign
      // 新しい名刺の初期値を自動判定する
      this.modalMergePersonsConf_newerId = target.formatted_exdate >= candidate.bcards[0].formatted_exdate
        ? sidPerson : sidAssign
      this.modalMergePersonData_openflag = null // 空文字更新と区別するため
      this.modalMergePersonData_twitter_id = null // 空文字更新と区別するため
      this.modalMergePersonData_blog_url = null // 空文字更新と区別するため
      this.modalMergePersonData_memo = null // 空文字更新と区別するため
    },
    /**
     * 人物統合
     */
    mergePersons (openflag, twitter_id, blog_url, memo) {
      const vm = this
      this.modalMergePersonsConf_isOpen = false

      let params = {
        sid_persons: [
          this.modalMergePersonsConf_id1,
          this.modalMergePersonsConf_id2
        ],
        // V2で追加
        newer_id: this.modalMergePersonsConf_newerId
      }
      if (typeof openflag === 'string') params.openflag = openflag
      if (typeof twitter_id === 'string') params.twitter_id = twitter_id
      if (typeof blog_url === 'string') params.blog_url = blog_url
      if (typeof memo === 'string') params.memo = memo

      MergePersonRepository.merge(params)
        .then(function (response) {
          // 成功時
          if (vm.isApiSuccess(response)) {
            const data = vm.getApiData(response).data
            // 対象人物リロード（残ったほうの人物のIDを使う）
            vm.sidPerson = data.id
            vm._getTargetPersonData(vm.sidPerson)
            // 同一人物候補を一覧から消す
            vm.removePerson()
            // 判定済みとする
            vm.isJudged = vm.app_flag.ON
            vm.showToast('名刺人物が統合されました。', { type: 'success' })

            // お知らせ件数とサイドメニューの件数を更新する
            vm.$store.dispatch('reloadHeaderInfo')
            vm.$store.dispatch('reloadSidemenu')
          }
          // データ競合時
          else {
            const data = vm.getApiData(response).data
            if (data.code === 4221) {
              // 競合データを修正させる
              vm._openModalMergePersonData(data.competed)
            }
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
          vm.modalError_isOpen = true
          vm.modalError_title = '人物統合エラー'
        })
    },
    /*
     * 競合データ修正モーダルを開く
     * @param Array competed レスポンスの競合データ
     */
    _openModalMergePersonData (competed) {
      this.modalMergePersonData_isOpen = true
      this.modalMergePersonData_competed = competed
    },
    /*
     * どちらのXXXを使うか指定する
     */
    setCompetedField (fieldName, index) {
      this['modalMergePersonData_' + fieldName] = this.modalMergePersonData_competed[fieldName][index]
    },
    /*
     * 片方のメモをもう片方に追記する
     * @param integer direction right/left
     */
    copyCompetedField (fieldName, direction) {
      const maxlength = this.maxlengths.persons[fieldName]

      if (direction === 'right') {
        this.modalMergePersonData_competed[fieldName][this.modalMergePersonsConf_id2] = (
          this.modalMergePersonData_competed[fieldName][this.modalMergePersonsConf_id2] +
          this.modalMergePersonData_competed[fieldName][this.modalMergePersonsConf_id1]
        ).substr(0, maxlength)
        this.setCompetedField(fieldName, this.modalMergePersonsConf_id2)
      }
      else {
        this.modalMergePersonData_competed[fieldName][this.modalMergePersonsConf_id1] = (
          this.modalMergePersonData_competed[fieldName][this.modalMergePersonsConf_id1] +
          this.modalMergePersonData_competed[fieldName][this.modalMergePersonsConf_id2]
        ).substr(0, maxlength)
        this.setCompetedField(fieldName, this.modalMergePersonsConf_id1)
      }
      this.$forceUpdate()
    },
    /*
     * 競合修正後の人物統合前のバリデーション
     */
    validMergePersonsAgain () {
      if ('openflag' in this.modalMergePersonData_competed && this.modalMergePersonData_openflag === null) {
        return false
      }
      if ('twitter_id' in this.modalMergePersonData_competed && this.modalMergePersonData_twitter_id === null) {
        return false
      }
      if ('blog_url' in this.modalMergePersonData_competed && this.modalMergePersonData_blog_url === null) {
        return false
      }
      if ('memo' in this.modalMergePersonData_competed && this.modalMergePersonData_memo === null) {
        return false
      }
      return true
    },
    /*
     * 競合修正後の人物統合
     */
    mergePersonsAgain () {
      if (!this.validMergePersonsAgain()) {
        return
      }
      this.modalMergePersonData_isOpen = false

      if (IS_MOCK) {
        // mock用 統合成功後の処理
        const vm = this
        const data = {'id': 1}
        // 対象人物リロード（残ったほうの人物のIDを使う）
        vm.sidPerson = data.id
        vm._getTargetPersonData(vm.sidPerson)
        // 候補もリロード（統合したデータが候補から消えるため）
        // vm._getDuplicatesData(false)
        vm.removePerson()
        // 分割済み一覧を調整
        // vm._filterSplittedTargets([
        //   vm.modalMergePersonsConf_id1,
        //   vm.modalMergePersonsConf_id2
        // ])
        vm.showToast('名刺人物が統合されました。', { type: 'success' })
      }
      else {
        this.mergePersons(
          this.modalMergePersonData_openflag,
          this.modalMergePersonData_twitter_id,
          this.modalMergePersonData_blog_url,
          this.modalMergePersonData_memo
        )
      }
    },
    /**
     * 並び替え処理
     * @param object sort: 対象ソート項目
     */
    sortList (sort) {
      this.currParams.sort = sort
      this._getDuplicatesData({
        isSort: true
      })
    },
    openCard (item) {
      this.modalBcard.sidPerson = item.id
      this.modalBcard.isOpen = true
    },
    // 名刺の画像ダイアログ表示
    showCardImageModal (sid_bcard) {
      this.modalImages.isOpen = true
      this.modalImages.sid_bcard = sid_bcard
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
@import '~bootstrap-sass/assets/stylesheets/bootstrap/mixins';

.panel-heading {
  max-height: 55px;

  .duplicate-panel-heading {
    overflow: hidden;
  }

   > h4 {
    margin: 7px;
    @include text-overflow;
  }
}

// 左右移動
.carousel-control {
  height: 100px;
  i {
    width: 40px;
    height: 40px;

    background-color: $component-active-bg;
    border-radius: 100%;

    // background-color: $component-active-bg;
  }
  &.left > i {
    left: 50%;
    margin-left: -20px;
  }
  &.right > i {
    right: 50%;
    margin-right: -20px;
  }
}

//- 名刺情報カルーセル
.bcard-card-details-cardinfo-carousel {
  .carousel-control {
    i {
      background-color: #0073b7;
    }
    &:hover > i {
      background-color: #286090;
    }
  }
}

.scroll-sync-container {
  height: 400px;
  overflow: auto;

  @include webkitScrollbar();
}

.bcard-card-details-card-img {
  max-width: 100%;
  /*max-height: 150px;*/
}

.candidates {
  bottom: 0;
  margin-bottom: -20px;

  .list-group {
    display: flex;
    overflow-x: auto;
    padding-bottom: 15px;

    .list-group-item {
      position: relative;
      height: 9em;
      width: 400px;
      margin-right: 15PX;
    }

    .list-group-item:hover {
      cursor: pointer;
      background-color: #e6e6e6;
    }

    .list-group-item.selected{
      border: solid 2px #337ab7;
      background-color: #e6e6e6;
    }
  }

  .not-candidates {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 125px;
  }
}

.not-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;

  .return-list-btn {
    margin-left: 50px;
  }
}

.bcard-card-img {
  max-width: 100px;
  max-height: 150px;
}

.bcard-card-details-card-img {
  max-width: 100%;
  max-height: 300px;
}

// 同一人物登録の確認：共有メモ
.bcard-duplicate-inline > textarea {
  height: 109px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/maintenance/duplicated-persons/Detail.vue